<template>
  <q-dialog :model-value="modelValue" persistent @update:model-value="$emit('update:modelValue', $event)">
    <q-card class="neg-escopo neg-modal">
      <q-card-section class="neg-modal__titulo">
        {{ edicao ? "Editar oportunidade" : "Nova oportunidade" }}
      </q-card-section>

      <q-card-section class="neg-modal__corpo scroll" style="max-height: 70vh">
        <q-select
          v-model="cliente"
          use-input
          fill-input
          hide-selected
          clearable
          dense
          input-debounce="300"
          label="Cliente"
          hint="Busque por nome ou CPF. Não achou? digite o nome e confirme para cadastrar"
          new-value-mode="add-unique"
          option-label="label"
          :options="clientesEncontrados"
          :loading="buscandoCliente"
          :error="Boolean(erros.cadastro_id)"
          :error-message="primeiroErro('cadastro_id')"
          :disable="edicao"
          @filter="buscarCliente"
        />

        <q-input
          v-if="clienteNovo"
          v-model="dados.cliente_cpfcnpj"
          dense
          clearable
          label="CPF do novo cliente (opcional)"
          mask="###.###.###-##"
          hint="Vai criar um cadastro novo com este nome"
        />

        <q-select
          v-model="dados.linha_id"
          dense
          emit-value
          map-options
          :label="linhasExtras.length ? 'Linha principal' : 'Linha'"
          option-value="id"
          option-label="nome"
          :options="negociosLinhasAtivas"
          :error="Boolean(erros.linha_id)"
          :error-message="primeiroErro('linha_id')"
          @update:model-value="aplicarPercentualDaLinha"
        />

        <div v-for="(linhaExtra, indice) in linhasExtras" :key="indice" class="neg-linha-extra">
          <q-select
            v-model="linhaExtra.linha_id"
            dense
            emit-value
            map-options
            label="Outra linha"
            option-value="id"
            option-label="nome"
            class="neg-linha-extra__select"
            :options="opcoesLinhaExtra(indice)"
          />
          <q-field
            v-if="edicao"
            v-model="linhaExtra.valor_contratado"
            dense
            stack-label
            label="Valor contratado"
            class="neg-linha-extra__valor"
          >
            <template v-slot:control="{ id, floatingLabel, modelValue, emitValue }">
              <money-input
                :id="id"
                class="q-field__native text-right"
                :value="modelValue"
                v-bind="moneyFormat"
                v-show="floatingLabel"
                @input="emitValue"
              />
            </template>
          </q-field>
          <q-btn flat dense round icon="close" @click="removerLinha(indice)">
            <q-tooltip>Remover esta linha</q-tooltip>
          </q-btn>
        </div>

        <div class="neg-link" @click="acrescentarLinha">+ Acrescentar linha</div>

        <q-field
          v-model="dados.valor_solicitado"
          dense
          stack-label
          label="Valor solicitado"
          :error="Boolean(erros.valor_solicitado)"
          :error-message="primeiroErro('valor_solicitado')"
        >
          <template v-slot:control="{ id, floatingLabel, modelValue, emitValue }">
            <money-input
              :id="id"
              class="q-field__native text-right"
              :value="modelValue"
              v-bind="moneyFormat"
              v-show="floatingLabel"
              @input="emitValue"
            />
          </template>
        </q-field>

        <q-field
          v-if="edicao"
          v-model="dados.valor_contratado"
          dense
          stack-label
          bottom-slots
          :label="linhasExtras.length ? 'Valor contratado (desta linha)' : 'Valor contratado'"
          :hint="linhasExtras.length
            ? 'O que o banco aprovou para esta linha'
            : 'O que o banco aprovou. É sobre ele que a comissão é calculada'"
          :error="Boolean(erros.valor_contratado)"
          :error-message="primeiroErro('valor_contratado')"
        >
          <template v-slot:control="{ id, floatingLabel, modelValue, emitValue }">
            <money-input
              :id="id"
              class="q-field__native text-right"
              :value="modelValue"
              v-bind="moneyFormat"
              v-show="floatingLabel"
              @input="emitValue"
            />
          </template>
        </q-field>

        <div v-if="edicao && linhasExtras.length" class="neg-sub">
          Total contratado (soma das linhas, não digitável): {{ formatarMoeda(totalContratado) }}
        </div>

        <q-expansion-item
          v-if="!edicao"
          dense
          expand-separator
          label="Mais dados"
          header-class="neg-modal__mais"
        >
          <div class="neg-modal__corpo">
            <negocios-campos-simulacao :dados="dados" :erros="erros" :edicao="false" />
          </div>
        </q-expansion-item>

        <negocios-campos-simulacao v-else :dados="dados" :erros="erros" :edicao="true" />
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat no-caps label="Cancelar" @click="$emit('update:modelValue', false)" />
        <q-btn
          unelevated
          no-caps
          color="primary"
          :label="edicao ? 'Salvar' : 'Abrir oportunidade'"
          :loading="salvando"
          @click="salvar"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import MoneyInput from "@/components/Utils/money-input.vue";
import negociosMixin from "@/mixins/negocios";

function dadosVazios() {
  return {
    cadastro_id: null,
    cliente_nome: null,
    cliente_cpfcnpj: null,
    linha_id: null,
    funcionario_id: null,
    valor_solicitado: 0,
    valor_contratado: 0,
    prazo: null,
    taxa: null,
    valor_parcela: 0,
    protocolo: null,
    percentual_previsto: null,
    data_alerta: null
  };
}

export default {
  name: "negocios-modal-oportunidade",

  emits: ["update:modelValue", "salvou"],
  components: { MoneyInput },
  mixins: [negociosMixin],
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    oportunidade: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      dados: dadosVazios(),
      cliente: null,
      clientesEncontrados: [],
      linhasExtras: [],
      tinhaVariasLinhas: false,
      buscandoCliente: false,
      salvando: false,
      erros: {}
    };
  },
  computed: {
    ...mapGetters(["negociosLinhasAtivas", "negociosFuncionarios"]),
    edicao() {
      return Boolean(this.oportunidade && this.oportunidade.id);
    },
    clienteNovo() {
      return typeof this.cliente === "string" && this.cliente.length > 0;
    },
    usaVariasLinhas() {
      return this.linhasExtras.length > 0 || this.tinhaVariasLinhas;
    },
    totalContratado() {
      const extras = this.linhasExtras.reduce((soma, linha) => soma + Number(linha.valor_contratado || 0), 0);

      return Number(this.dados.valor_contratado || 0) + extras;
    }
  },
  watch: {
    modelValue(aberto) {
      if (aberto) {
        this.preencher();
      }
    }
  },
  methods: {
    preencher() {
      this.erros = {};
      this.dados = dadosVazios();
      this.linhasExtras = [];
      this.tinhaVariasLinhas = false;

      if (!this.edicao) {
        this.cliente = null;
        this.clientesEncontrados = [];
        return;
      }

      const origem = this.oportunidade;
      const linhas = Array.isArray(origem.linhas) ? origem.linhas : [];
      const variasLinhas = linhas.length > 1;

      this.cliente = origem.cliente ? { id: origem.cliente.id, label: origem.cliente.nome } : null;
      this.dados = {
        ...dadosVazios(),
        cadastro_id: origem.cadastro_id,
        linha_id: origem.linha_id,
        funcionario_id: origem.funcionario_id,
        valor_solicitado: Number(origem.valor_solicitado || 0),
        valor_contratado: variasLinhas
          ? Number((linhas[0] && linhas[0].valor_contratado) || 0)
          : Number(origem.valor_contratado || 0),
        prazo: origem.prazo,
        taxa: origem.taxa,
        valor_parcela: Number(origem.valor_parcela || 0),
        protocolo: origem.protocolo,
        percentual_previsto: origem.percentual_previsto,
        data_alerta: origem.data_alerta
      };

      if (variasLinhas) {
        this.tinhaVariasLinhas = true;
        this.linhasExtras = linhas.slice(1).map(linha => ({
          linha_id: linha.id,
          valor_contratado: Number(linha.valor_contratado || 0)
        }));
      }
    },
    buscarCliente(termo, atualizar, abortar) {
      if (!termo) {
        return abortar();
      }

      this.buscandoCliente = true;

      this.$store.dispatch("buscarNegociosClientes", termo).then(cadastros => {
        this.buscandoCliente = false;

        atualizar(() => {
          this.clientesEncontrados = cadastros.map(cadastro => ({
            id: cadastro.id,
            label: cadastro.cpfcnpj ? cadastro.nome + " · " + cadastro.cpfcnpj : cadastro.nome
          }));
        });
      });
    },
    aplicarPercentualDaLinha(linhaId) {
      const linha = this.negociosLinhasAtivas.find(item => item.id === linhaId);

      if (linha && !this.edicao) {
        this.dados.percentual_previsto = linha.percentual_comissao;
      }
    },
    acrescentarLinha() {
      this.linhasExtras.push({ linha_id: null, valor_contratado: 0 });
    },
    removerLinha(indice) {
      this.linhasExtras.splice(indice, 1);
    },
    opcoesLinhaExtra(indice) {
      const escolhidas = [this.dados.linha_id];

      this.linhasExtras.forEach((linha, outroIndice) => {
        if (outroIndice !== indice) {
          escolhidas.push(linha.linha_id);
        }
      });

      return this.negociosLinhasAtivas.filter(linha => escolhidas.indexOf(linha.id) === -1);
    },
    valorOuNulo(valor) {
      return valor ? Number(valor) : null;
    },
    montarLinhas() {
      const principal = {
        linha_id: this.dados.linha_id,
        valor_contratado: this.valorOuNulo(this.dados.valor_contratado)
      };

      if (this.dados.percentual_previsto !== null && this.dados.percentual_previsto !== undefined &&
        this.dados.percentual_previsto !== "") {
        principal.percentual_previsto = this.dados.percentual_previsto;
      }

      const extras = this.linhasExtras.map(linha => ({
        linha_id: linha.linha_id,
        valor_contratado: this.valorOuNulo(linha.valor_contratado)
      }));

      return [principal, ...extras];
    },
    montarPayload() {
      const payload = { ...this.dados };

      if (this.clienteNovo) {
        payload.cadastro_id = null;
        payload.cliente_nome = this.cliente;
      } else if (this.cliente && this.cliente.id) {
        payload.cadastro_id = this.cliente.id;
        payload.cliente_nome = null;
      }

      ["valor_solicitado", "valor_contratado", "valor_parcela"].forEach(campo => {
        if (!payload[campo]) {
          payload[campo] = null;
        }
      });

      if (!this.edicao) {
        delete payload.valor_contratado;
        delete payload.data_alerta;
      }

      if (this.usaVariasLinhas) {
        payload.linhas = this.montarLinhas();
        delete payload.linha_id;
        delete payload.valor_contratado;
        delete payload.percentual_previsto;
      }

      return payload;
    },
    salvar() {
      this.salvando = true;
      this.erros = {};

      const id = this.edicao ? this.oportunidade.id : null;

      this.$store
        .dispatch("salvarNegociosOportunidade", { id, dados: this.montarPayload() })
        .then(resposta => {
          this.salvando = false;

          if (!resposta.success) {
            this.erros = resposta.errors || {};

            this.avisar(resposta.message, "orange");

            return;
          }

          this.avisar(resposta.message, "green");

          this.$emit("salvou", resposta.oportunidade);
          this.$emit("update:modelValue", false);
        });
    }
  }
};
</script>
